export const MODAL_KEYS = {
  SELECT_TENANT: 'SELECT_TENANT',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  INACTIVITY_LOGOUT: 'INACTIVITY_LOGOUT',
  USER_AGREEMENT: 'USER_AGREEMENT',
  INVESTIGATION_REPORT: 'INVESTIGATION_REPORT',
  FILTERING_MODAL: 'FILTERING_MODAL',
  ADD_NEW_INVESTIGATION: 'ADD_NEW_INVESTIGATION',
  ADD_NEW_USER: 'ADD_NEW_USER',
  DELETE_USER: 'DELETE_USER',
  CREATE_API_KEY: 'CREATE_API_KEY',
  DELETE_API_KEY: 'DELETE_API_KEY',
} as const;

export type ModalKeyType = keyof typeof MODAL_KEYS;
